/**
 * AI Helper for handling chatbot messages and responses
 */

/**
 * Handle AI message processing for the Rafiq chatbot
 * @param {string} input - The user's input message
 * @param {Array} history - The conversation history
 * @param {Array} initialChatOptions - The initial chat options to display
 * @returns {Object} - Response object with message and nextOptions
 */
export const handleAIMessage = async (input, history, initialChatOptions) => {
    const text = input.trim().toLowerCase();

    // Greeting
    if (text.match(/^(hi|hello|مرحبا|اهلا|سلام|السلام عليكم)/)) {
        return {
            message: "أهلاً بك! أنا رفيق، كيف يمكنني مساعدتك في رحلتك التعليمية اليوم؟",
            nextOptions: initialChatOptions
        };
    }

    // Registration / Account
    if (text.match(/(تسجيل|حساب|جديد|register|account|signup)/)) {
        return {
            message: "يمكنك استكشاف خدماتنا والتواصل معنا عند الحاجة.",
            nextOptions: [
                { text: "خدماتنا", value: "services" },
                { text: "تواصل معنا", value: "contact" },
                { text: "عودة للقائمة", value: "back" }
            ]
        };
    }

    // Login
    if (text.match(/(دخول|login|signin|log in)/)) {
        return {
            message: "للمساعدة في الوصول لحسابك يمكنك التواصل معنا.",
            nextOptions: [
                { text: "تواصل معنا", value: "contact" },
                { text: "عودة للقائمة", value: "back" }
            ]
        };
    }

    // Services General
    if (text.match(/(خدمة|خدمات|service|feature)/)) {
        return {
            message: "نقدم مجموعة متنوعة من الخدمات التعليمية. ماذا تود أن تعرف؟",
            nextOptions: [
                { text: "الامتحانات", value: "exams" },
                { text: "الدورات", value: "courses" },
                { text: "المدونات", value: "blogs" },
                { text: "عرض كل الخدمات", value: "services" }
            ]
        };
    }

    // Exams
    if (text.match(/(امتحان|اختبار|exam|test|quiz)/)) {
        return {
            message: "خدمة الامتحانات لدينا توفر بيئة آمنة وتفاعلية. يمكنك تجربة الامتحانات أو معرفة المزيد.",
            nextOptions: [
                { text: "معرفة المزيد عن الامتحانات", value: "exams" },
                { text: "الخدمات الأخرى", value: "services" }
            ]
        };
    }

    // Courses
    if (text.match(/(دورة|كورس|course|video|فيديو)/)) {
        return {
            message: "لدينا دورات تدريبية شاملة في مختلف المواد.",
            nextOptions: [
                { text: "استعراض الدورات", value: "courses" },
                { text: "الخدمات الأخرى", value: "services" }
            ]
        };
    }

    // Blogs
    if (text.match(/(مدونة|مقال|blog|article|تفاعل)/)) {
        return {
            message: "شارك المعرفة وتفاعل مع الآخرين عبر المدونات.",
            nextOptions: [
                { text: "تصفح المدونات", value: "blogs" },
                { text: "الخدمات الأخرى", value: "services" }
            ]
        };
    }

    // Contact
    if (text.match(/(تواصل|اتصل|contact|help|مساعدة|support|دعم)/)) {
        return {
            message: "نحن هنا لمساعدتك دائماً.",
            nextOptions: [
                { text: "تواصل معنا", value: "contact" },
                { text: "معلومات عنا", value: "about" }
            ]
        };
    }

    // Default fallback
    return {
        message: "عذراً، لم أفهم تماماً. هل يمكنك الاختيار من القائمة أدناه أو توضيح سؤالك؟",
        nextOptions: initialChatOptions
    };
};

export default handleAIMessage;
